sharpen-back {
  display: block;
  margin-bottom: var(--spacing-md);
  font-size: var(--font-size-xs);

  .sharpen-icon {
    font-size: 20px;
    vertical-align: -5px;
    opacity: 0.8;
  }
}